 
import $ from 'jquery';
import ko from 'knockout';
import Category from "./category";
import page from '../../../smartpak/page';
import '../../../../jsscripts/jquery/printThis';

function Quiz(data, win) {
    var utils = ko.utils,
        minLowRisk = 0,
        maxLowRisk = 10,
        minModerateRisk = 11,
        maxModerateRisk = 24,
        minHighRisk = 25,
        hasColicSurgeryVal = 13,
        fifthDietQuestion = 4,
        sixthDietQuestion = 5,
        $category = $('#category'),
        $body = $('body'),
        $mobile = page.isMobile(),
        openModal;

    this.isSpeUser = false;

    // Part for Categories
    this.sections = ko.observableArray(
        utils.arrayMap(data.sections, function(category) {
            return new Category(category);
        })
    );

    this.grabCatContents = ko.computed(() => {
        var answer = [];

        utils.arrayForEach(this.sections(), function(category) {
            answer = answer.concat(category.questions());
        });

        return answer;
    });

    this.results = ko.computed(() => {
        var responses = this.grabCatContents();

        return utils.arrayMap(responses, function(question) {
            return question.response();
        });
    });

    this.total = ko.computed(() => {
        var result = 0,
            amount = this.results(),
            i = 0;

        for (; i < amount.length; i++) {
            result += +amount[i];
        }

        return result;
    });

    // Part for the Risk Levels
    this.levels = ko.observableArray(
        utils.arrayMap(data.levels, function(level) {
            return level;
        })
    );

    this.riskColor = ko.observable('');

    this.surgery = ko.computed(() => {
        var response = this.results()[hasColicSurgeryVal],
            surgery = 'No';

        if (response === '5') {
            surgery = 'Yes';
        } else {
            surgery = 'No';
        }

        return surgery;
    });

    // Part for the Introduction Page
    this.intro = ko.observableArray(
        utils.arrayMap(data.intro, function(gender) {
            return gender;
        })
    );

    this.gender = ko.observable('');

    this.horse = ko.observable('');

    this.genderType = ko.computed(() => {
        var gender = 'his';

        if (this.gender() === 'Mare') {
            gender = 'her';
        }

        return gender;
    });

    // Functions for Quiz
    this.getSectionByName = function(name) {
        return utils.arrayFilter(this.sections(), function(section) {
            return section.name === name;
        })[0];
    };

    this.getHash = function() {
        var hash = window.location.hash;

        hash = hash.replace(/^#\//, '');

        return hash;
    };

    this.introBtn = function() {
        var name = $(this.getHash() + ' input[type="button"]').attr('name'),
            check = false,
            horseName = $('input[name="horse"]').val(),
            genderSelect = $('input[name="gender"]').is(':checked');

        if (name === 'intro') {
            if (horseName === '') {
                check = false;
            }
            if (genderSelect === false) {
                check = false;
            }
            if (horseName !== '' && genderSelect === true) {
                check = true;
            }
        }

        this.errorMsg(check, 'Exercise', 'intro');
    };

    this.sectionBtn = function() {
        var name = $(this.getHash() + ' input[type="button"]').attr('name'),
            check = false,
            amount = 0,
            result = 0,
            section = this.getSectionByName(name),
            i = 0;

        check =
            utils.arrayFilter(section.questions(), function(question) {
                return question.response() === '';
            }).length === 0;

        amount = utils.arrayMap(section.questions(), function(question) {
            return question.response();
        });

        for (; i < amount.length; i++) {
            result += +amount[i];
        }

        if (result > 0) {
            section.showTitle(true);
        } else {
            section.showTitle(false);
        }

        this.errorMsg(check, section.next, section.name);
    };

    this.errorMsg = function(check, next, name) {
        var msg =
                'Looks like we missed a spot! Please circle back and answer all of the questions before moving on to the next page.',
            $error = $('.error');

        if (!check) {
            $error.html(msg).show();
        } else {
            $('#' + name).addClass('catHide');
            history.pushState(null, null, '#' + next);
            this.grabHash();
            $error.hide();
            if (name === 'History') {
                openModal = this.resultsModal();
            }
        }
    };

    this.grabHash = function() {
        var hash = this.getHash(),
            $hideCategory = $('body').find('.catShow'),
            $intro = $('#intro'),
            $risk = $('.riskMeter');

        if (hash) {
            $hideCategory.addClass('catHide').removeClass('catShow');
            $(hash)
                .removeClass('catHide')
                .addClass('catShow');
            $('.sections')
                .removeClass('catHide')
                .addClass('catShow');
            $intro.addClass('catHide');
            win.scrollTop(0);
        } else {
            $hideCategory.addClass('catHide').removeClass('catShow');
            $intro.removeClass('catHide');
        }

        if (hash === '#Results') {
            $risk.hide();
        } else {
            $risk.show();
        }
    };

    this.resultsModal = function() {
        var $modal = $('#modal'),
            $newModal;

        if ($mobile) {
            $newModal = $modal.clone();
            $newModal = $newModal.removeClass('catHide');

            smartPak.ui.modal($newModal.get(0), {title: 'Colic Risk Assessor Results'});
        } else {
            smartPak.ui.modal('#modal', {
                modal: true,
                resizable: false,
                width: 800,
                closeText: ' '
            });

            win.scrollTop(0);
        }
    };

    this.subQuestion = function(open, input, num) {
        var $sub = $('.sub'),
            manage = this.getSectionByName('Diet');

        if (open > 0) {
            $sub.show();
            input.prop('checked', false);
            manage.questions()[num].response('');
        } else if (open == 0) {
            $sub.hide();
            input.prop('checked', true).trigger('click');
        }
    };

    this.checkImage = function(input, image) {
        input.attr('src', image);
    };

    this.riskLevel = function() {
        var risk = this.total(),
            level = '';

        if (risk >= minLowRisk && risk <= maxLowRisk) {
            level = 'low';
            this.riskLevelColor('green', 'greenArrow', '/images/colicare/riskAssessor/6_Meter_LOW.png');
        } else if (risk >= minModerateRisk && risk <= maxModerateRisk) {
            level = 'moderate';
            this.riskLevelColor('yellow', 'yellowArrow', '/images/colicare/riskAssessor/6_Meter_MEDIUM.png');
        } else if (risk >= minHighRisk) {
            level = 'high';
            this.riskLevelColor('red', 'redArrow', '/images/colicare/riskAssessor/6_Meter_HIGH.png');
        }

        return level;
    };

    this.riskLevelColor = function(color, addArrow, image) {
        var $arrow = $('.modalArrow');

        this.riskColor('header ' + color);
        $arrow.removeClass('greenArrow yellowArrow redArrow');
        $arrow.addClass(addArrow);
        $('.riskMeter')
            .find('img')
            .attr('src', image);
    };

    win.on('popstate', () => {
        this.grabHash();
        $('.error').hide();
        if (openModal) {
            openModal.close();
        }
    });

    win.ready(() => {
        var hash = this.getHash();

        if (hash) {
            window.location.assign('/horse-colic-risk-factors-quiz');
        }
    });

    $('.findOutHowCloseModal').on('click', function() {
        if ($mobile) {
            $('.mobileModal')
                .find('.mmCloseButton')
                .trigger('click');
        } else if (openModal) {
            openModal.close();
        }

        win.scrollTop(0);
    });

    $body.on('click', '.printLink', function() {
        $('#modal').printThis();
    });

    $category.on('click touchstart', 'input[name="diet4"]', (e) => {
        var open = $(e.currentTarget).val(),
            $diet5 = $('input[name="diet5"][value="0"]'),
            $diet6 = $('input[name="diet6"][value="0"]');

        this.subQuestion(open, $diet5, fifthDietQuestion);
        this.subQuestion(open, $diet6, sixthDietQuestion);
    });

    $category.on('click touchstart', '.spanClick', (e)  => {
        e.preventDefault();

        var $this = $(e.currentTarget),
            $label = $this.parent('label');

        $label
            .find('input')
            .prop('checked', true)
            .trigger('click');

        this.riskLevel();
    });

    $category.on('click touchstart', '.modalResults', (e) => {
        e.preventDefault();
        openModal = this.resultsModal();
    });

    $category.on('click touchstart', '#intro input[type="button"]', function() {
        window.dataLayer.push({event: 'facebookPageLoad'});
    });

    $category.on('click touchstart', '#History input[type="button"]', function() {
        window.dataLayer.push({event: 'facebookConversion', transactionTotal: '0.00'});
    });
}

export default Quiz;